import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";

  return (
    <div
      className={`flex flex-col ${
        isCenter ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"
      } gap-4 md:gap-8`}
    >
      <div className={isCenter ? "max-w-2xl" : "max-w-2xl"}>
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-primary-600 mb-3">
            <span className="w-6 h-px bg-primary-400" />
            {eyebrow}
          </span>
        )}
        <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 text-balance leading-snug">
          {title}
        </h2>
        {description && (
          <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}